var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var $ = require("./lib/qsa");

var onWindowLoaded = function() {
  pym.then(child => {
      var table = $.one("#grid");
      table.classList.add("collapsed");

      var expandButton = $.one("button.expander");
      expandButton.addEventListener("click", function() {
        var collapsed = table.classList.toggle("collapsed");
        console.log(collapsed);
        expandButton.innerHTML = collapsed ? "Show more" : "Show less";
        child.sendHeight();
        // child.scrollParentToChildEl("grid");
      });


      child.sendHeight();
      window.addEventListener("resize", () => child.sendHeight());

  });
}

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);